
import { defineStore } from "pinia"
import { ref, computed } from 'vue'
import { useApiStore, apiIdOf, API_ORIGIN, axiosRetryx } from "@/stores/api"
import { apiDefaultDescriptions, type ApiOptions } from "@/stores/api"

export const useBannersStore = defineStore('banners', () => {
  type BannerInfo = {
    image_url: string
    link_url: string
    image_url2: string | null
    link_url2: string | null
    // 1枚目から順の画像。古いAPIでは返らない
    images?: { image_url: string, link_url: string }[]
    background_color_code: string
  }
  type BannerImage = {
    imageUrl: string
    linkUrl: string
  }

  const { apiCall, checkResponseError } = useApiStore()
  // 1枚目から順のバナー画像
  const bannerImages = ref<BannerImage[]>([])
  // 1枚目の画像URL。バナーを表示するかどうかの判定に使う
  const bannerImageUrl = computed(() => bannerImages.value[0]?.imageUrl ?? '')
  const backgroundColorCode = ref<string | null>(null)

  /** バナー情報取得API */
  const getBannerInfo = async (args: { __apiOptions?: ApiOptions }) =>  {
    const apiOptions = args.__apiOptions || {}
    apiOptions.apiId = apiIdOf('getBannerInfo');

    return await apiCall<BannerInfo>(apiOptions, async (apiConfig) => {
      const url = API_ORIGIN + "/getbannerinfo";
      const data = {
      }

      const response = await axiosRetryx({ method: 'post', url, data, ...apiConfig })

      const descriptions = {
        ...apiDefaultDescriptions,
      }

      if (checkResponseError(response, descriptions, apiOptions)) {
        return;
      }
      return response.data.banner_info;
    })
  }

  const initBanner = async () => {
    // バナー情報を取りに行く
    const args = { __apiOptions: { noErrorDialog: true, noDisplayLoading: true } }
    const bannerInfo = await getBannerInfo(args)
    if(bannerInfo) {
      // images が無い古いAPIの場合は、1枚目・2枚目の項目から組み立てる
      const images = bannerInfo.images ?? [
        { image_url: bannerInfo.image_url, link_url: bannerInfo.link_url },
        ...(bannerInfo.image_url2 ? [{ image_url: bannerInfo.image_url2, link_url: bannerInfo.link_url2 ?? '' }] : []),
      ]
      bannerImages.value = images.map((image) => ({ imageUrl: image.image_url, linkUrl: image.link_url }))
      backgroundColorCode.value = bannerInfo.background_color_code
      return;
    }
    // エラーの場合
    bannerImages.value = []
    backgroundColorCode.value = null
  }

  return {
    bannerImages,
    bannerImageUrl,
    backgroundColorCode,
    initBanner,
  }
})
